import * as React from "react";
import { toINR } from "../../../../service/numberFormat";

export interface IHoldMfUnusableRowDskProps {
	rowData: any;
}

const HoldMfUnusableRowDsk: React.FC<IHoldMfUnusableRowDskProps> = props => {
	return (
		<li className="data_row">
			<div className="col companyName robotoM">
				<span dangerouslySetInnerHTML={{ __html: props.rowData.companyName }}></span>
			</div>
			<div className="col category">{props.rowData.category}</div>
			<div className="col pledgQty w_80">{toINR(props.rowData.pledgQty)}</div>
			<div className="col lockedInQty w_80">{toINR(props.rowData.lockedInQty)}</div>
			<div className="col ltp w_80">{toINR(props.rowData.LTP)}</div>
			<div className="col holdingValue w_90">{toINR(props.rowData.holdingValue)}</div>
		</li>
	);
};

export default HoldMfUnusableRowDsk;
